import { ILoginReqParams } from '@/core/domain/entities/request';
import { logout, pinCheck, userLogin, checkSession, createAddress } from '@/services/api/UserApi';
import { getStores } from '@/stores';
import { toUser } from '../transfer/toUser';
import { errorCodes } from '@/services/api/errorCodes';
import { IResponseUser } from '@/core/domain/entities/user';
import { response as ErrorResponse } from '@/services/api/errorCodes copy';
import { replaceNewLineToTag } from '@/utils';

/**
 * 로그인 컨트롤러
 * @param {ILoginReqParams} loginData
 * @returns {Promise<{succed: boolean, errorProcceded?: boolean, errorMessage?: string, errorCount?: string}>}
 */
export async function login(
  loginData: ILoginReqParams,
): Promise<{ succed: boolean; errorProcceded?: boolean; errorMessage?: string; errorCount?: string }> {
  const { userStore } = getStores();
  try {
    const res = await userLogin(loginData);

    if (res.status === 'error') {
      const errorResult = res as { response: ErrorResponse; status: string; errorCount: number };

      return {
        succed: false,
        errorProcceded: true,
        errorMessage: replaceNewLineToTag(res.message),
        errorCount: errorResult.errorCount ? errorResult.errorCount.toString() : undefined,
      };
    } else {
      userStore.setUser(toUser(res.response as IResponseUser));

      return { succed: true };
    }

    // 에러 코드(문자열)인 경우
    // if ('errorCode' in res) {
    //   const errorInfo = errorCodes.find((error) => error.code === res.errorCode);
    //   if (errorInfo) {
    //     showAlertPopup(
    //       replaceNewLineToTag(errorInfo.message),
    //       true,
    //       false,
    //       res.errorCount ? res.errorCount.toString() : undefined,
    //     );
    //     return { succed: false, errorProcceded: true, errorMessage: errorInfo.message };
    //   }
    //   return { succed: false }; // 에러 코드는 있지만 매칭되는 메시지가 없는 경우
    // }

    // if ('status' in res) {
    //   const errorInfo = errorCodes2.find((error) => error.errorCode.code === res);
    // }
  } catch (err) {
    console.error(err);

    return { succed: false };
  }
}

/**
 * 인증번호 체크
 * @param {string} id
 * @param {string} pin
 * @returns {Promise<{succed: boolean, errorProcceded?: boolean, errorMessage?: string}>}
 */
export async function tryPinCheck(
  id: string,
  pin: string,
): Promise<{ succed: boolean; errorProcceded?: boolean; errorMessage?: string }> {
  try {
    const res = await pinCheck({ id, pin });

    if (res.status === 'error') {
      return { succed: false, errorProcceded: true, errorMessage: res.message };
    } else {
      return { succed: true };
    }
    // 에러 코드(문자열)인 경우
    // if (typeof res === 'string') {
    //   const errorInfo = errorCodes.find((error) => error.code === res);
    //   if (errorInfo) {
    //     return { succed: false, errorProcceded: true, errorMessage: errorInfo.message };
    //   }
    //   return { succed: false };
    // }
  } catch (error) {
    console.error(error);

    return { succed: false };
  }
}

/**
 * 로그아웃
 * @returns {Promise<{succed: boolean, errorProcceded?: boolean, errorMessage?: string}>}
 */
export async function tryLogout(): Promise<{ succed: boolean; errorProcceded?: boolean; errorMessage?: string }> {
  try {
    await logout();

    return { succed: true };
  } catch (error) {
    console.error(error);
    return { succed: false };
  }
}

/**
 * 세션 체크 후 로그인 페이지로 리다이렉트
 * @returns {Promise<boolean>}
 */
export async function checkSessionAndRedirect(): Promise<boolean> {
  const { userStore } = getStores();
  try {
    const { isLoggedIn, user } = await checkSession();

    if (!isLoggedIn || userStore.isLogout) {
      // 로그인 페이지로 리다이렉트
      window.location.href = '/login';
      return false;
    }

    // 로그인된 상태면 유저 정보 저장
    userStore.setUser(toUser(user));
    return true;
  } catch (err) {
    console.error('Session check failed:', err);
    window.location.href = '/login';
    return false;
  }
}

/**
 * 현재 세션의 유저 정보 조회
 * @returns {Promise<IUser | null>}
 */
export async function getSessionUser() {
  const { userStore } = getStores();
  try {
    const { isLoggedIn, user } = await checkSession();

    if (!isLoggedIn || !user) {
      return null;
    }

    // 로그인된 상태면 유저 정보 저장하고 반환
    const userData = toUser(user);
    userStore.setUser(userData);
    return userData;
  } catch (err) {
    console.error('Get session user failed:', err);
    return null;
  }
}

/**
 * 주소 생성 컨트롤러
 * @param {string} id
 * @param {string} phone
 * @returns {Promise<{succed: boolean, errorProcceded?: boolean, errorMessage?: string}>}
 */
export async function tryCreateAddress(
  id: string,
  phone: string,
): Promise<{
  succed: boolean;
  errorProcceded?: boolean;
  errorMessage?: string;
}> {
  try {
    const res = await createAddress(id, phone);

    // 에러 코드(문자열)인 경우
    if (typeof res === 'string') {
      const errorInfo = errorCodes.find((error) => error.code === res);
      if (errorInfo) {
        return { succed: false, errorProcceded: true, errorMessage: errorInfo.message };
      }
      return { succed: false };
    }

    return { succed: true };
  } catch (error) {
    console.error(error);

    return { succed: false };
  }
}
